// Statuses defined here - https://www.iana.org/assignments/dns-parameters/dns-parameters.xhtml#dns-parameters-6
var DomainStatus;
(function (DomainStatus) {
    DomainStatus[DomainStatus["NoError"] = 0] = "NoError";
    DomainStatus[DomainStatus["NXDomain"] = 3] = "NXDomain";
})(DomainStatus || (DomainStatus = {}));
export class DNSOverHTTPSResolver {
    #logger;
    #dnsServer;
    constructor(options) {
        this.#logger = options.logger;
        this.#dnsServer = options.dnsServer;
    }
    async resolve(hostname, type, dnssecVerification) {
        const dnsResponse = await this.#executeDNSQuery(hostname, type);
        // NXDomain error is treated as a valid response, but with no answer.
        if (dnsResponse.Status === DomainStatus.NXDomain) {
            this.#logger.trace(`Received NXDomain response for ${hostname}.`);
            return undefined;
        }
        if (dnsResponse.Status !== DomainStatus.NoError) {
            // TODO: do we want to retry internally on some status codes?
            throw new Error(`Received error status from DNS server: ${dnsResponse.Status}.`);
        }
        if (!dnsResponse.AD && dnssecVerification) {
            // Event if empty response is received, it should still be validated using DNSSEC, to prevent Resolution Downgrade Attack.
            throw new Error(`DNS response for ${hostname} was not verified using DNSSEC. Response is ignored.`);
        }
        const answers = dnsResponse.Answer?.filter((answer) => answer.type === type);
        return answers?.map((answer) => ({
            type: answer.type,
            value: answer.data,
            ttl: answer.TTL,
        }));
    }
    async #executeDNSQuery(hostname, type) {
        const queryURL = new URL(this.#dnsServer);
        queryURL.searchParams.set('name', hostname);
        queryURL.searchParams.set('type', type.toString());
        this.#logger.trace(`Performing DNS over HTTPS lookup: ${queryURL.toString()}`);
        // TODO: do we want to add retries for network errors?
        const fetchResponse = await fetch(queryURL, {
            headers: new Headers({
                accept: 'application/dns-json',
            }),
        });
        const dnsResponse = await fetchResponse.json();
        this.#logger.trace(`DNS over HTTPS lookup response: ${JSON.stringify(dnsResponse)}`);
        return dnsResponse;
    }
}
//# sourceMappingURL=dns-resolver.js.map